const webkitBoundary = '--WebKitFormBoundary7MA4YWxkTrZu0gW';
const returnBuffer = (str) => {
    const encoder = new TextEncoder();
    return encoder.encode(str).buffer;
};
const concatenateBuffers = (buffers) => {
    const mergedLength = buffers.reduce((sum, buffer) => sum + buffer.byteLength, 0);
    let position = 0;
    return buffers.reduce((mergedBuffer, buffer) => {
        mergedBuffer.set(new Uint8Array(buffer), position);
        position += buffer.byteLength;
        return mergedBuffer;
    }, new Uint8Array(mergedLength)).buffer;
};
const createArrayBufferFromFormData = async (uploadedFile, caseDetailsObject) => {
    const binaryFile = await uploadedFile.arrayBuffer();
    const startBoundary = `--${webkitBoundary}\r\n` +
        'Content-Disposition: form-data; name="caseDetails"\r\n\r\n' +
        `${JSON.stringify(caseDetailsObject)}\r\n` +
        `--${webkitBoundary}\r\n` +
        `Content-Disposition: form-data; name="fileSegments"; filename="${caseDetailsObject.partyDetails[0].attachmentDetails[0].fileName}"\r\n` +
        `Content-Type: ${caseDetailsObject.partyDetails[0].attachmentDetails[0].contentType}\r\n\r\n`;
    const endBoundary = `\r\n--${webkitBoundary}--`;
    const startBoundaryBuffer = returnBuffer(startBoundary);
    const endBoundaryBuffer = returnBuffer(endBoundary);
    const arrayBuffer = concatenateBuffers([
        startBoundaryBuffer,
        binaryFile,
        endBoundaryBuffer,
    ]);
    return arrayBuffer;
};
export const uploadFileInAndroid = async (latestJWT, uploadedFile, caseDetailsObject, iaLabClient) => {
    const fileHeaders = {
        'X-ACCESS-TOKEN': `${latestJWT}`,
        'Content-Type': `multipart/form-data; boundary=${webkitBoundary}`,
    };
    const payload = await createArrayBufferFromFormData(uploadedFile, caseDetailsObject);
    const response = await iaLabClient.post('/cases/files', payload, {
        headers: fileHeaders,
    });
    return response;
};
//# sourceMappingURL=androidHelper.js.map